<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="simulationValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :disabled="published && !duplicating"
                :error="errors.get('name')">
            </base-input>

            <base-input class="mb-3" v-if="!duplicating"
                :label="$t('common.description')"
                name="description"
                :error="errors.get('description')"
            >
                <textarea class="form-control" rows="5"
                    :placeholder="$t('common.description')"
                    v-model="value.description"
                ></textarea>
            </base-input>

            <date-input class="mb-3"
                :label="$t('common.edition')"
                label-classes="form-control-label required"
                name="edition"
                rules="required"
                v-model="value.edition"
                :error="errors.get('edition')">
            </date-input>

            <div class="row mb-3">
                <div class="col-6">
                    <base-radio name="1" v-model="position">
                        {{ positionName(1) }}
                    </base-radio>
                    <base-radio name="2" v-model="position"
                        v-if="degree.simulation_role_2"
                    >
                        {{ positionName(2) }}
                    </base-radio>
                </div>
            </div>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },

            degree: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                position: null
            }
        },

        created() {
            this.errors.setValidator('simulationValidator', this)
        },

        watch: {

            value(val) {
                this.position = this.value.use_simulation_role2 ? '2' : '1'
            },

            position: {
                handler(position) {
                    this.value.use_simulation_role2 = position == '2'
                },
                immediate: true
            },

            duplicating(val) {
                if (this.duplicating) {
                    this.value.name += ' (copy)'
                }
            }
        },

        computed: {

            published() {
                return this.degree.status == 'active'
            }
        },

        methods: {

            positionName(position) {
                if (!this.degree.lang) {
                    return ''
                }
                return this.degree['simulation_role_' + position + '_name'][this.degree.lang]
            },

            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
